import "./ComponentSpinner.css"

export const ComponentSpinner = () => {




    return (
        <svg className="loader" viewBox="0 0 384 384">
            <circle
                className="active"
                pathLength="360"
                fill="transparent"
                stroke-width="32"
                cx="192"
                cy="192"
                r="176"
            ></circle>
            <circle
                className="track"
                pathLength="360"
                fill="transparent"
                stroke-width="32"
                cx="192"
                cy="192"
                r="176"
            ></circle>
        </svg>
    )
}